import ENVIRONMENT_VAR from "@/src-refactor/modules/shared/model/const/env/env.const";
import useUserHelp from "@rf-hooks/useUserHelp";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import {
  EmailShareBtn,
  FBShareBtn,
  TelegramShareBtn,
  TwitterShareBtn
} from "dv-social-share";

const WhatsAppIconBtn = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.success.main,
  borderRadius: "50%",
  width: 33,
  height: 33,

  "&:hover": {
    backgroundColor: theme.palette.success.main
  },
  svg: {
    width: 30,
    height: 30,
    color: theme.palette.success.contrastText
  }
}));

import * as React from "react";
import Menu from "@mui/material/Menu";
import { Grid, IconButton, styled, TypographyProps } from "@mui/material";

export interface MxMenuItemProps<T = any> {
  label: string;
  icon?: React.ReactNode; // icon is now optional
  onClick?: (item: MxMenuItemProps<T>["data"]) => void;
  data?: T;
  show?: boolean; // show is now optional
  template?: React.ReactNode;
  color?: TypographyProps["color"];
}

interface MxMenuSocialProps {
  children: React.ReactNode;
  propertyType: string;
  bussinesType: string;
  sector: string;
  propertyId: string;
}

const ITEM_HEIGHT = 48;

export default function MxMenuSocial({ children, ...props }: MxMenuSocialProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { USER } = useUserHelp();

  const formattedPropertyType = props?.propertyType
    .replaceAll("/", "-o-")
    .replaceAll(" ", "-")
    .replace(/-o--+/g, "-o-")
    .replace(/--o-+/g, "-o-")
    .toLowerCase();

  const data = {
    url: `${ENVIRONMENT_VAR.REMAX_DOMAIN}/propiedad/${formattedPropertyType}/${props.propertyId}?referer=${USER?.userData?.people_id}`,
    title: `${props?.propertyType.replaceAll("/", "-o-")} en ${
      props?.bussinesType
    } en ${props?.sector}`,
    suject: `${props?.propertyType.replaceAll("/", "-o-")} en ${
      props?.bussinesType
    } en ${props?.sector}`,
    body: `${props?.propertyType.replaceAll("/", "-o-")} en ${
      props?.bussinesType
    } en ${props?.sector} \n `
  };

  const onRedirectCustomWhatsApp = () => {
    const urlWhatsapp = `https://wa.me/?text=${encodeURIComponent(
      `${data.title} ${data.url}`
    )}`;

    window.open(urlWhatsapp, "_blank");
  };

  const itemSocial: MxMenuItemProps[] = [
    {
      icon: <EmailShareBtn url={data.url} subject={data.suject} body={data.body} />,
      label: "Email"
    },
    {
      icon: <FBShareBtn url={data.url} quote="REMAX/RD" />,
      label: "Facebook"
    },
    {
      icon: <TwitterShareBtn url={data.url} title={data.title} />,
      label: "Twitter"
    },
    {
      icon: (
        <WhatsAppIconBtn onClick={onRedirectCustomWhatsApp}>
          <IconBrandWhatsapp size={20} />
        </WhatsAppIconBtn>
      ),
      label: "WhatsApp"
    },
    {
      icon: <TelegramShareBtn url={data.url} title={data.title} />,
      label: "Telegram"
    }
  ];

  return (
    <div>
      <div onClick={handleClick}>{children}</div>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button"
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              padding: 5,
              maxHeight: ITEM_HEIGHT * 4.5,
              maxWidth: 150
            }
          }
        }}
      >
        <ContentButtons container columns={3} alignItems={"center"} spacing={1}>
          {itemSocial.map(item => (
            <Grid item xs={1} alignItems={"center"}>
              {item.icon}
            </Grid>
          ))}
        </ContentButtons>
      </Menu>
    </div>
  );
}

const ContentButtons = styled(Grid)(({ theme }) => ({}));
